/**
 * DesignStudioLocation
 *
 * Location wrapper for the Products/Design Studio view.
 * Maps to the "Products" tab in the original navigation.
 */

import React from 'react';
import { CampusLocation } from '../../types/spatial';
import LocationWrapper from '../spatial/LocationWrapper';
import { ProductsView } from '../tycoon/ProductsView';

// Re-export the props type from ProductsView if needed
export type DesignStudioLocationProps = React.ComponentProps<typeof ProductsView>;

export const DesignStudioLocation: React.FC<DesignStudioLocationProps> = (props) => {
  return (
    <LocationWrapper
      location={CampusLocation.DESIGN_STUDIO}
      title="Design Studio"
    >
      <ProductsView {...props} />
    </LocationWrapper>
  );
};

export default DesignStudioLocation;
